/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_No_ActivityInputs */

const vi_stocktake_filter_no_activity = /** @type {(inputs: Stocktake_Filter_No_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không biến động`)
};

/**

* @param {Stocktake_Filter_No_ActivityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_no_activity = /** @type {((inputs?: Stocktake_Filter_No_ActivityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_No_ActivityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_no_activity(inputs)
});